import { TuiNotificationService } from "@taiga-ui/core";
import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../../features/auth/services/auth.service';
import { PermissionsService } from '../auth/permissions.service';
import { showUnauthorizedAlert } from '../utils/alert-helper.util';

const ADMIN_ONLY_TABS = ['users', 'roles', 'videos', 'team-videos', 'global-settings', 'support'];

export const settingsAdminGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const alerts = inject(TuiNotificationService);
  const permissions = inject(PermissionsService);

  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    showUnauthorizedAlert(alerts, 'unauthenticated', {
      sessionExpiredRecently: authService.sessionExpiredRecently(),
    });
    const trigger = router.getCurrentNavigation()?.trigger;
    if (trigger === 'imperative') {
      return false;
    }
    return router.createUrlTree(['/home']);
  }

  const tab = route.queryParamMap.get('tab');

  if (tab && ADMIN_ONLY_TABS.includes(tab)) {
    if (permissions.isAdmin()) {
      return true;
    }
    showUnauthorizedAlert(alerts, 'forbidden');
    const trigger = router.getCurrentNavigation()?.trigger;
    if (trigger === 'imperative') {
      return false;
    }
    return router.createUrlTree(['/home']);
  }

  return true;
};
